// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"PX-z","sponsoredTooltipWrapper":"QX-z","sponsoredTooltip":"RX-z","newCard":"SX-z"};